<template>
  <div class="flex grow-0">
    <div
      v-if="modelValue?.lendflow || modelValue?.client"
      v-tooltip="tooltipText"
      class="flex items-center gap-1"
    >
      <icon-base
        v-if="modelValue?.lendflow"
        height="16"
        width="16"
        icon="logo-blue"
        view-box="4 0 20 30"
      />
      <template v-if="modelValue?.client">
        <div
          v-if="modelValue?.lendflow && modelValue?.client"
          class="text-xs text-primary"
        >
          +
        </div>
        <icon-base
          height="16"
          width="16"
          icon="organization"
          view-box="0 1 16 16"
        />
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import type { IApplication, StageManagement } from "@/models/applications";
import type { PropType } from "vue";

const props = defineProps({
  modelValue: {
    type: Object as PropType<StageManagement | null>,
    default: null,
  },
  model: {
    type: Object as PropType<IApplication | null>,
    default: null,
  },
});

const { t } = useI18n();

const tooltipText = computed(() => {
  if (props.modelValue?.lendflow && props.modelValue?.client) {
    return t("COMMON.LENDFLOW_ORGANIZATION", {
      name: props.model?.client?.name || t("DEALS.ORGANIZATION"),
    });
  } else if (props.modelValue?.lendflow) {
    return t("COMMON.LENDFLOW");
  } else if (props.modelValue?.client) {
    return props.model?.client?.name || t("DEALS.ORGANIZATION");
  } else {
    return "";
  }
});
</script>
